export default "__VITE_ASSET___Hpx$QVD__"